import { AppSettingsService } from "@services/appSettings.service";

export function CheckGroupPermissions(appSettingsService: AppSettingsService, groupName: string) {
	const groups = appSettingsService.get("groups", "");
	const groupArray = groups?.split(",");
	return groupArray?.includes(groupName);
}